import type { SystemStyleObject } from '@chakra-ui/react';

export const forgotPasswordCss: SystemStyleObject = {
  '&': {
    width: 'full',
    gap: 6,
  },

  '& .instructions': {
    textAlign: 'center',
    color: 'fg.muted',
  },

  '& .back-link': {
    fontSize: 'sm',
    alignSelf: 'center',
  },
};
